import React from "react";
import { Link as GatsbyLink } from "gatsby";
import type { GatsbyLinkProps } from "gatsby";

export default function Link<TState>({ children, ...props }: React.PropsWithoutRef<GatsbyLinkProps<TState>>) {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  return <GatsbyLink<TState> {...props}>{children}</GatsbyLink>;
}
